/**
 * @generated SignedSource<<f38afc5cf1ecbca3e793116d0b0f529a>>
 * @relayHash 7658ddb717a4b391d8bc81365920180f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7cc8812baff3574b87484e9d4defb2826a8648c8a0740eba6603ac7e78f303c5

import type { ConcreteRequest, Query } from 'relay-runtime';
export type TopNavigationQuery$variables = {
  includeNav4AdminOptIn: boolean;
};
export type TopNavigationQuery$data = {
  readonly siteConfiguration: {
    readonly customSiteLogo: boolean;
  } | null | undefined;
  readonly siteDescription: {
    readonly logoUrl: string | null | undefined;
  } | null | undefined;
  readonly siteSettings: {
    readonly isNav4OptedIn?: boolean;
    readonly showApplicationTitle: boolean;
    readonly siteTitle: string;
  } | null | undefined;
  readonly user: {
    readonly displayName: string | null | undefined;
    readonly emails: ReadonlyArray<{
      readonly isPrimary: boolean | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
    readonly id: string | null | undefined;
    readonly photos: ReadonlyArray<{
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type TopNavigationQuery = {
  response: TopNavigationQuery$data;
  variables: TopNavigationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "includeNav4AdminOptIn"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "value"
},
v2 = [
  {
    "concreteType": "SiteConfiguration",
    "kind": "LinkedField",
    "name": "siteConfiguration",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "customSiteLogo"
      }
    ]
  },
  {
    "concreteType": "SiteSettings",
    "kind": "LinkedField",
    "name": "siteSettings",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "siteTitle"
      },
      {
        "kind": "ScalarField",
        "name": "showApplicationTitle"
      },
      {
        "condition": "includeNav4AdminOptIn",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "isNav4OptedIn"
          }
        ]
      }
    ]
  },
  {
    "concreteType": "SiteDescription",
    "kind": "LinkedField",
    "name": "siteDescription",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "logoUrl"
      }
    ]
  },
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "displayName"
      },
      {
        "concreteType": "AtlassianUserEmail",
        "kind": "LinkedField",
        "name": "emails",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "ScalarField",
            "name": "isPrimary"
          }
        ]
      },
      {
        "concreteType": "AtlassianUserPhoto",
        "kind": "LinkedField",
        "name": "photos",
        "plural": true,
        "selections": [
          (v1/*: any*/)
        ]
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "TopNavigationQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TopNavigationQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "7658ddb717a4b391d8bc81365920180f",
    "id": "7cc8812baff3574b87484e9d4defb2826a8648c8a0740eba6603ac7e78f303c5",
    "metadata": {},
    "name": "TopNavigationQuery",
    "operationKind": "query",
    "text": "query TopNavigationQuery($includeNav4AdminOptIn:Boolean!){siteConfiguration{customSiteLogo},siteSettings{siteTitle,showApplicationTitle,isNav4OptedIn@include(if:$includeNav4AdminOptIn)},siteDescription{logoUrl},user:confluence_atlassianUser(current:true){id,displayName,emails{value,isPrimary},photos{value}}}"
  }
};
})();

(node as any).hash = "60341092e84fcf290aa2d48438186979";

export default node;
